const clientData = [
    {
        id: 1,
        img: require('../images/Home/Clients/merck.png')
    },
    {
        id: 2,
        img: require('../images/Home/Clients/viiv.png')
    },
    {
        id: 3,
        img: require('../images/Home/Clients/convatec.png')
    },
    {
        id: 5,
        img: require('../images/Home/Clients/advanz.png')
    },
    {
        id: 6,
        img: require('../images/Home/Clients/ucb.png')
    },
    {
        id: 7,
        img: require('../images/Home/Clients/BMS.png')
    },
    {
        id: 8,
        img: require('../images/Home/Clients/AZ.png')
    },
    {
        id: 9,
        img: require('../images/Home/Clients/KK.png')
    },
    {
        id: 10,
        img: require('../images/Home/Clients/zambon.png')
    },
    {
        id: 11,
        img: require('../images/Home/Clients/Novartis.png')
    },
    {
        id: 12,
        img: require('../images/Home/Clients/Argenix.png')
    },
    {
        id: 13,
        img: require('../images/Home/Clients/otsuka.png')
    },
    {
        id: 14,
        img: require('../images/Home/Clients/gsk.png')
    },
    {
        id: 15,
        img: require('../images/Home/Clients/chiesi.png')
    },
    {
        id: 16,
        img: require('../images/Home/Clients/Johnson.png')
    },
    {
        id: 17,
        img: require('../images/Home/Clients/CSL.png')
    },
    {
        id: 18,
        img: require('../images/Home/Clients/jazz.png')
    },
    {
        id: 19,
        img: require('../images/Home/Clients/regeneron.png')
    },
    {
        id: 20,
        img: require('../images/Home/Clients/Janssen.png')
    },
    {
        id: 21,
        img: require('../images/Home/Clients/Bayer.png')
    }
]

export default clientData;